import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { Popup } from "@/Common/Components/Modals/Popup";
import { DocumentTreeClassControl } from "@/Common/Helpers/DocumentTreeClassControl";
import { DocumentClassModel } from "@/Common/Models/DocumentClassModel";
import { Guid } from "@/Common/Models/Guid";

import "./EditDocumentClassesPopup.css";

interface IEditDocumentClassesPopupProps {
    selectedClasses: (Guid | string)[];
    onCancel: () => void;
    onSave: (selectedClasses: (Guid | string)[]) => void;
}
class EditDocumentClassesPopupState {
    public selectedClasses: (Guid | string)[] = [];

    public constructor(init?: Partial<EditDocumentClassesPopupState>) {
        Object.assign(this, init);
    }
}

class EditDocumentClassesPopup extends BaseReactComponent<IEditDocumentClassesPopupProps, EditDocumentClassesPopupState> {
    private documentClasses: DocumentClassModel[];

    public constructor(props: IEditDocumentClassesPopupProps) {
        super(props);
        this.documentClasses = DocumentTreeClassControl.GetDocumentClasses().toArray();
        this.state = new EditDocumentClassesPopupState({
            selectedClasses: this.props.selectedClasses ?? []
        });
    }

    public render(): JSX.Element {
        return (
            <div className="triage-form-edit-classes-popup">
                <Popup
                    title={cacheStore.GetString("DocumentClassesLabel")}
                    draggable
                    onCloseDelegate={() => this.props.onCancel()}
                    manageOverlay
                    isOverflowVisible={true}
                    topPosition={150}
                    leftPosition={700}
                    width={365}
                    titleLowerCase={true}
                    standardFooterProps={{
                        cancelButton: {
                            label: cacheStore.GetString("CancelLabel"),
                            onClick: () => { this.props.onCancel(); }
                        },
                        okButton: {
                            label: cacheStore.GetString("SaveLabel"),
                            onClick: () => { this.props.onSave([...this.state.selectedClasses]); }
                        }
                    }}
                >
                    <div className="document-class-list">
                        {this.documentClasses.map((documentClass: DocumentClassModel) => (
                            <div key={"class_" + documentClass.LookupId}>
                                <CheckboxControl
                                    id={documentClass.LookupId}
                                    label={documentClass.Name}
                                    checked={this.state.selectedClasses.contains(documentClass.LookupId)}
                                    onChange={isChecked => this.toggleSelectDocumentClass(isChecked, documentClass.LookupId)}
                                />
                            </div>
                        ))}
                    </div>
                </Popup>
            </div>
        );
    }

    private toggleSelectDocumentClass(isChecked: boolean, documentClass: string): void {
        this.mutateState(s => {
            s.selectedClasses = isChecked
                ? [...s.selectedClasses, documentClass].distinct()
                : s.selectedClasses.filter(p => p !== documentClass);
        });
    }
}
export { EditDocumentClassesPopup };
